import {
  Point2,
  LineSegment2,
} from '../../../../domain/geometry/geometric-types';
import { SheetShapeDeepFragment } from '../../../../gql/graphql';

export enum KileTypeSKU {
  RW80110 = 'RW80110',
  RW80111 = 'RW80111',
  RW80112 = 'RW80112',
  RW257379 = 'RW257379',
  RW257426 = 'RW257426',
  RW257435 = 'RW257435',
  RW257437 = 'RW257437',
  RW257439 = 'RW257439',
  RW257440 = 'RW257440',
  RW257441 = 'RW257441',
  RW257442 = 'RW257442',
  INVALID_KILE = 'Invalid-kile',
}

export type Kile = {
  length: number;
  type: KileTypeSKU;
  name: string;
};

export type Diamond = {
  triangle1: boolean;
  triangle2: boolean;
  triangle3: boolean;
  triangle4: boolean;
};

export type WedgeCalculationResult = {
  points: Point2[];
  kileTypes: KileTypeSKU[];
  diamonds: Diamond[];
  segmentLengths?: number[];
  mousePosition?: Point2;
};

export type DragStateType = 'none' | 'start' | 'end' | 'middle';

export type EdgeMatchResult = {
  edge: LineSegment2;
  shape: SheetShapeDeepFragment;
  distance: number;
  isCloserThan100mm: boolean;
  isOnLeftSide: boolean | null;
} | null;
